import moment from 'moment';

function getTimestampFromCreatedDate(createdAt) {
  // Same day
  if (createdAt.isSame(new Date(), 'day')) {
    return createdAt.fromNow();
  }

  // Yesterday
  if (createdAt.isSame(moment().subtract(1, 'days'), 'day')) {
    return `Yesterday at ${createdAt.format('h:mma')}`;
  }

  return createdAt.format('h:mma');
}

export default getTimestampFromCreatedDate;